<div class="dropdown">
  <div class="dropdown-header flex items-center">
    <ng-container *ngIf="currentUser$ | async as user; else defaultDropdownAvatar">
      <ng-container *ngIf="user.imagen; else dropdownInitials">
        <div class="dropdown-heading-icon flex-none rounded-full overflow-hidden">
          <img [src]="user.imagen" class="w-full h-full object-cover" alt="Avatar" />
        </div>
      </ng-container>
      <ng-template #dropdownInitials>
        <div
          class="dropdown-heading-icon flex items-center justify-center rounded-full text-base font-bold select-none"
          [style.background-color]="getAvatarColor(user)"
          [style.color]="'#374151'">
          {{ getInitials(user) }}
        </div>
      </ng-template>
      <div class="dropdown-heading">{{ getUserDisplayName(user) }}</div>
    </ng-container>
    <ng-template #defaultDropdownAvatar>
      <div class="dropdown-heading-icon flex items-center justify-center">
        <mat-icon svgIcon="mat:person"></mat-icon>
      </div>
      <div class="dropdown-heading">Usuario Invitado</div>
    </ng-template>
  </div>

  <div class="dropdown-content">
    <a
      (click)="close()"
      *ngFor="let item of items; trackBy: trackById"
      [routerLink]="item.route"
      class="notification flex items-center"
      matRipple>
      <mat-icon
        [ngClass]="item.colorClass"
        [svgIcon]="item.icon"
        class="notification-icon flex-none"></mat-icon>
      <div class="flex-auto">
        <div class="notification-label">{{ item.label }}</div>
        <div class="notification-description">{{ item.description }}</div>
      </div>
      <mat-icon
        class="notification-chevron flex-none"
        svgIcon="mat:chevron_right"></mat-icon>
    </a>
  </div>

  <div class="dropdown-footer flex items-center justify-end">
    <button (click)="logout()" color="primary" mat-button type="button">
      Cerrar sesión
    </button>
  </div>
</div>
